/* eslint-disable camelcase */
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { AppState } from "../../../../redux";

import Update2Fa from "./Update2Fa";
import ChangePassword from "./ChangePassword";

/**
 * Renders the security settings tab of the user account section.
 *
 * This includes:
 * - A form to change the user's password
 * - An optional 2FA configuration panel, depending on security policy
 *
 * @returns A React component containing password and 2FA management
 */
const UserAccountSecurityTab: React.FC = () => {
  const {
    user: { currentUser },
    securitySettings: { securitySettings },
  } = useSelector((state: AppState) => state);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={8} md={6}>
        <ChangePassword />
      </Grid>
      <Grid item xs={12} sm={8} md={6}>
        {!securitySettings.enforce_2fa_globally &&
        securitySettings.enable_2fa &&
        currentUser ? (
          <Update2Fa user={currentUser} />
        ) : null}
      </Grid>
    </Grid>
  );
};

export default UserAccountSecurityTab;
